export default __webpack_public_path__ + "media/double-logo.77adf.png";